import http from "src/utils/http";
import moment from "moment";

export const AVAILABLE_SLOTS_PATH =
  "/api/general/individual/offer/details/available-slots";

export function formatAvailableSlotsDate(date) {
  return moment(date).format("YYYY-MM-DD");
}

/**
 * Fetch generated, already-filtered slots for one selected day.
 * Reusable across booking-request, individual booking, reschedule, and mobile.
 */
export async function fetchAvailableSlots({
  offerId,
  userId,
  organizationId,
  selectedDate,
  clientTimezone,
  excludeAppointmentId,
}) {
  const { data } = await http.get(AVAILABLE_SLOTS_PATH, {
    params: {
      offer_id: offerId,
      user_id: userId,
      organization_id: organizationId,
      selected_date: formatAvailableSlotsDate(selectedDate),
      client_timezone: clientTimezone,
      ...(excludeAppointmentId
        ? { exclude_appointment_id: excludeAppointmentId }
        : {}),
    },
  });

  return data;
}

export function slotsFromAvailableSlotsResponse(data) {
  return Array.isArray(data?.slots) ? data.slots : [];
}

/**
 * Apply an available-slots response to the shared DateAndTime UI state.
 */
export function applyAvailableSlotsToUi(
  data,
  {
    setSessionList,
    setOverFlowTimeToRender,
    setUnderFlowTimeToRender,
    setAllUpcommingAppt,
  }
) {
  setSessionList(slotsFromAvailableSlotsResponse(data));

  if (setOverFlowTimeToRender) {
    setOverFlowTimeToRender([]);
  }

  if (setUnderFlowTimeToRender) {
    setUnderFlowTimeToRender([]);
  }

  if (setAllUpcommingAppt) {
    setAllUpcommingAppt({ events: [] });
  }

  return data;
}

export async function loadAndApplyAvailableSlots({
  offerId,
  userId,
  organizationId,
  selectedDate,
  clientTimezone,
  excludeAppointmentId,
  setSessionList,
  setOverFlowTimeToRender,
  setUnderFlowTimeToRender,
  setAllUpcommingAppt,
}) {
  const data = await fetchAvailableSlots({
    offerId,
    userId,
    organizationId,
    selectedDate,
    clientTimezone,
    excludeAppointmentId,
  });

  return applyAvailableSlotsToUi(data, {
    setSessionList,
    setOverFlowTimeToRender,
    setUnderFlowTimeToRender,
    setAllUpcommingAppt,
  });
}

